import React from "react";

import {useMediaQuery} from "react-responsive";
import logodiv from "./assets/images/vector.png";
const Partner = () => {
    const isBigScreen = useMediaQuery({query: "(min-width: 750px)"});
    const isTabletOrMobile = useMediaQuery({query: "(max-width: 600px)"});
    return (
        <div className="wrapper">
            {isBigScreen && <h1
                className="mb-20 text-center text-1xl text-blue"
                style={{
                color: "#4267B2",
                fontSize: 36,
                fontWeight: '700'
            }}>
                “Dengan semua kelebihan dan kesuksesan para mitra Trawlbens yang sudah
                bergabung, Anda tak perlu ragu lagi untuk gabung menjadi Mitra Space. Dapatkan
                harga promo spesial Ramadhan sekarang! Daftar sebelum lebaran! hanya 7 juta dari
                harga normal 30 juta. Setelah kembali ke fitrah, Anda sudah punya usaha baru
                bersama Trawlbens“
            </h1>
}
            {isTabletOrMobile && <h1
                className="mb-20 text-center text-1xl text-blue"
                style={{
                color: "#4267B2",
                fontSize: 22,
                fontWeight: '700'
            }}>
                “Dengan semua kelebihan dan kesuksesan para mitra Trawlbens yang sudah
                bergabung, Anda tak perlu ragu lagi untuk gabung menjadi Mitra Space. Dapatkan
                harga promo spesial Ramadhan sekarang! Daftar sebelum lebaran! hanya 7 juta dari
                harga normal 30 juta. Setelah kembali ke fitrah, Anda sudah punya usaha baru
                bersama Trawlbens“
            </h1>
}
            <div className="container mx-auto mx-45 px-0">
              <div className="flex-container md:flex-row flex-col-reverse">
                <div className="flex-item">
                  <div>
                    {isBigScreen && <h1 className="pr-8 font-bold text-[28px] w-auto ml-[12px]">
                      Dengan modal 7 juta, Anda akan mendapatkan
                    </h1>}
                    <div className="items-center mb-19 flex mt-4 ml-4">
                      <img className="flex-none h-6 md:h-14" src={logodiv} alt=""/>
                      <div className=" flex-1 w-64">
                          <h1 className="pr-8 font-bold w-auto ml-[12px] text-[12.25px] leading-4 md:text-[26px] md:leading-9">
                            Sistem aplikasi Mitra-Space
                          </h1>
                          <p className="pr-8 font-light w-auto ml-[12px] text-[9.42px] leading-3 md:w-[400px] md:text-[20px] md:leading-6">
                            Dapatkan perangkat lunak untuk memproses pesanan hingga mengatur bisnis logistik Anda dengan lebih efisien.
                          </p>
                      </div>
                    </div>
                    <div className="items-center mb-19 flex mt-4 ml-4">
                      <img className="flex-none h-6 md:h-14" src={logodiv} alt=""/>
                      <div className="flex-1 w-64">
                          <h1 className="pr-8 font-bold w-auto ml-[12px] text-[12.25px] leading-4 md:text-[26px] md:leading-9">
                            Support Marketing Online
                          </h1>
                          <p className="pr-8 font-light w-auto ml-[12px] text-[9.42px] leading-3 md:w-[400px] md:text-[20px] md:leading-6">
                            Raih keuntungan lebih cepat dengan bantuan pemasaran online untuk menemukan calon pelanggan anda
                          </p>
                      </div>
                    </div>
                    <div className="items-center mb-19 flex mt-4 ml-4">
                      <img className="h-6 md:h-14 flex-none" src={logodiv} alt=""/>
                      <div className="flex-1 w-64">
                          <h1 className="pr-8 font-bold w-auto ml-[12px] text-[12.25px] leading-4 md:text-[26px] md:leading-9">
                            Atribut mitra lengkap
                          </h1>
                          <p className="pr-8 font-light w-auto ml-[12px] text-[9.42px] leading-3 md:w-[400px] md:text-[20px] md:leading-6">
                            Dapat atribut agen, berupa: kemeja, jaket, helm dan tas box kurir Trawlbens
                          </p>
                      </div>
                    </div>
                    <div className="items-center mb-19 flex mt-4 ml-4">
                      <img className="h-6 md:h-14 flex-none" src={logodiv} alt=""/>
                      <div className="flex-1 w-64">
                          <h1 className="pr-8 font-bold w-auto ml-[12px] text-[12.25px] leading-4 md:text-[26px] md:leading-9">
                            Neon Box & Timbangan Digital
                          </h1>
                          <p className="pr-8 font-light w-auto ml-[12px] text-[9.42px] leading-3 md:w-[400px] md:text-[20px] md:leading-6">
                            Dapat Neon Box sesuai ukuran yang ditentukan, sebagai penanda bahwa Anda adalah Mitra-Space Trawlbens
                          </p>
                      </div>
                    </div>
                </div>
                </div>
                <div className="flex-item">
                {isTabletOrMobile && <h1 className="pr-8 font-bold text-[28px] w-auto ml-[12px]">
                      Dengan modal 7 juta, Anda akan mendapatkan
                    </h1>}
                <img
                  src="https://media.graphassets.com/SaMWMgEuQGDLTqHTDOIl"
                  alt=""
                  className="w-full"
                />
                </div>
              </div>
                <div className="container mt-10 mx-auto mx-45 px-0">
                  <div className="flex-container">
                    <div className="flex-iframe">
                    {isTabletOrMobile && <h1 className="mb-5 font-bold font-center w-auto text-[16px] md:text-[40px] md:leading-normal">
                        Kata Mitra kami yang sudah sukses
                      </h1>}
                      <iframe 
                        className="w-full lg:w-5/6 h-full"
                        src={`https://www.youtube.com/embed/K1zX9-a78aw`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Embedded youtube"
                      />
                    </div>
                    <div className="flex-iframe mt-20 md:mt-0">
                      {isBigScreen && <h1 className="mb-5 font-bold font-center w-auto text-[16px] md:text-[40px] md:leading-normal">
                        Kata Mitra kami yang sudah sukses
                      </h1>}
                      <p className="mb-5 text-[12px] ml-[px] md:text-[20px] md:leading-6">
                        Cerita sukses para mitra bisnis Trawlbens yang telah bergabung
                      </p>
                      <p
                          className="mb-8 text-[11px] md:text-[20px] md:leading-6"
                          style={{
                          color: "blue",
                          fontStyle: 'italic'
                      }}>
                        "anda beruntung join mitra Trawlbens sekarang, karena Trawlbens sudah tersebar
                        keseluruh indonesia, tarif murah, aplikasi stabil, sistem sudah saat baik, beda
                        dengan saya 2 tahun lalu, mengawali dengan sangat berat, tapi saya merasakan
                        hasilnya"
                      </p>
                    </div>
                  </div>
                    <div className="fixed-right">
                        <a href="https://wa.me/6281399000000">
                            <button
                                className="bg-hijau text-putih py-2 px-8 rounded-full mb-4 text-sm font-bold md:text-lg md:py-2 md:px-12 md:mr-2">
                                <div className="flex gap-2">
                                    <img
                                        src="https://img.icons8.com/material-outlined/36/ffffff/whatsapp--v1.png"
                                        alt="whatsapp"
                                        className="h-2/6 pt-0 md:pt-2"/>
                                    <div>
                                        <p>Marketing & Sales</p>
                                        <p>0813 99 000 000</p>
                                    </div>
                                </div>
                            </button>
                        </a>
                    </div>
                </div>

                <div className="fixed-right">
                    <a href="https://wa.me/6281399000000">
                        <button
                            className="bg-hijau text-putih py-2 px-8 rounded-full mb-4 text-sm font-bold md:text-lg md:py-2 md:px-12 md:mr-2">
                            <div className="flex gap-2">
                                <img
                                    src="https://img.icons8.com/material-outlined/36/ffffff/whatsapp--v1.png"
                                    alt="whatsapp"
                                    className="h-2/6 pt-0 md:pt-2"/>
                                <div>
                                    <p>Marketing & Sales</p>
                                    <p>0813 99 000 000</p>
                                </div>
                            </div>
                        </button>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Partner;
